import { OpportunitiesApi } from '@/api';
import { Empty } from '@/models';
import {
  OpportunityDraft,
  OpportunityDraftListItem,
  NewOpportunityDraft,
  OpportunityItemOtherStatus,
} from '@/models/opportunities';

import { Module } from 'vuex';
import { Actions } from './actions';
import { Mutations } from './mutations';
import { RootState } from './root.store';

const opportunitiesApi = new OpportunitiesApi();

export interface OpportunitiesDraftsState {
  opportunitiesDrafts: OpportunityDraftListItem[];
  current: OpportunityDraft;
}

export const OpportunitiesDraftsModule: Module<OpportunitiesDraftsState, RootState> = {
  state: {
    opportunitiesDrafts: [] as OpportunityDraftListItem[],
    current: Empty.opportunityDraft as OpportunityDraft,
  },

  mutations: {
    [Mutations.opportunities.drafts.setOpportunitiesDrafts](state, items: OpportunityDraftListItem[]) {
      state.opportunitiesDrafts = items;
    },
    [Mutations.opportunities.drafts.addOpportunitiesDrafts](state, items: OpportunityDraftListItem[]) {
      state.opportunitiesDrafts.push(...items);
    },
    [Mutations.opportunities.drafts.setCurrent](state, item: OpportunityDraft) {
      state.current = item;
    },
  },

  actions: {
    async [Actions.opportunities.drafts.fetchOpportunitiesDrafts]({ commit }): Promise<void> {
      const items = await opportunitiesApi.fetchOpportunitiesDrafts();
      commit(Mutations.opportunities.drafts.setOpportunitiesDrafts, items);
    },
    async [Actions.opportunities.drafts.fetchCurrent]({ commit }, id: string): Promise<void> {
      const item = await opportunitiesApi.fetchOpportunityDraft(id);
      item.status = OpportunityItemOtherStatus.Draft;
      commit(Mutations.opportunities.drafts.setCurrent, item);
    },
    async [Actions.opportunities.drafts.delete](_, id: string): Promise<void> {
      return await opportunitiesApi.deleteOpportunityDraft(id);
    },
    async [Actions.opportunities.drafts.create](_, item: NewOpportunityDraft): Promise<OpportunityDraft> {
      return await opportunitiesApi.createOpportunityDraft(item);
    },
    async [Actions.opportunities.drafts.edit](_, item: OpportunityDraft & {id: string}): Promise<void> {
      return await opportunitiesApi.editOpportunityDraft(item);
    },
  },
};
